export enum APP_PATH {
  HOME = '/',
  DOCUMENTS = 'documents',
  PLANT_SELECT = 'plant-select',
  PLANT_INFOS = 'plant-infos',
  DOWNLOAD = 'download',
  CGU = 'cgu',
  EQUIPMENTS = 'equipments',
  POWER_PLANT_EXPORT_DATA = 'centrales/export-power-plants-data',
  API_DOCUMENTATION = 'api-documentation',
}
